import _ from 'underscore';
import { useMemo, useContext } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { getRoutePathById, allSiteMap } from '@bingads-webui-react/with-site-map';

import { TIP_ID } from './consts';

export const useActionButtons = ({
  serverContext, getLocalizedSupportLink, i18n, hasPaymentPermission, isPaymentFirstTile, hasCoupon, showWelcomeMsg, logOnClick,
}) => {
  const { scope } = useContext(ScopeContext) as any;

  return useMemo(() => {
    const ccBaseUrlNoTrailingSlash = _.get(serverContext, ['Urls', 'ClientCenterBaseUrl'], '').replace(/\/$/, '');
    return ({
      [TIP_ID.PROMO]: [{
        text: i18n.getString(_TL_('See promotional offers')),
        onClick: () => {
          logOnClick('welcome-promo');
          scope.save(`${ccBaseUrlNoTrailingSlash}${getRoutePathById(allSiteMap, 'coupon')}`);
        },
        analyticsId: 'welcome-coupon-status',
      }],
      [TIP_ID.CREATE_CAMPAIGN]: [{
        text: i18n.getString(_TL_('Create campaign')),
        onClick: () => {
          logOnClick('welcome-create-campaign');
          scope.save(getRoutePathById(allSiteMap, 'campaign-create-objective'));
        },
        analyticsId: hasCoupon ? 'welcome-create-campaign-coupon' : 'welcome-create-campaign',
      }],
      [TIP_ID.ADD_PAYMENT]: [{
        text: i18n.getString(_TL_('Do this now')),
        onClick: () => {
          logOnClick('welcome-add-payment');
          if (!hasPaymentPermission) {
            return;
          }
          scope.set({ ...scope.values, showTaxForm: false });
          scope.save(`${ccBaseUrlNoTrailingSlash}${getRoutePathById(allSiteMap, 'paymentMethods')}`);
        },
        analyticsId: showWelcomeMsg && isPaymentFirstTile ? 'welcome-add-payment-first' : 'welcome-add-payment-second',
      }],
      [TIP_ID.COACHING]: [{
        text: i18n.getString(_TL_('Learn more')),
        onClick: () => {
          logOnClick('welcome-coaching');
          scope.save(getLocalizedSupportLink({
            Culture: serverContext.CurrentLocale,
          }).coachingLink);
        },
        analyticsId: 'welcome-onboarding-consultation',
      }],
      [TIP_ID.HELP]: [{
        text: i18n.getString(_TL_('Learn more')),
        onClick: () => { },
        analyticsId: 'welcome-help',
        helpId: 'ext51022',
      }],
    });
  }, [i18n, hasCoupon, showWelcomeMsg, isPaymentFirstTile, scope, hasPaymentPermission, getLocalizedSupportLink, serverContext, logOnClick]);
};
